import { Component, OnInit, OnDestroy } from "@angular/core";
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';
import { SubscriptionUtil } from 'src/app/_utilities/subscription';
import {ActivatedRoute, Router} from "@angular/router";
import {XeroService} from "src/app/_services/xero.service";
import { ErrorUtil } from "src/app/_utilities/error";
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: "app-xero-connection-status",
  templateUrl: "./xero-connection-status.component.html",
  styleUrl: "./xero-connection-status.component.scss",
  standalone: false,
})
export class XeroConnectionStatusComponent
  extends SubscriptionUtil
  implements OnInit, OnDestroy
{
  time: any = 5;
  translate: any;

  constructor(
    private languageTranslateService: LanguageTranslateService,
    private route: ActivatedRoute,
    private xeroServc: XeroService,
    private errorUtil: ErrorUtil,
    private router: Router,
    private spinner: NgxSpinnerService,
  ) {
    super();
  }

  ngOnInit() {
    this.getLanguageData();
    this.route.queryParamMap.subscribe((params) => {
      const code: any = params.get("code");
      // const realmId: any = params.get("realmId");
      const state: any = params.get("state");
      this.sendDataToFieldEx(code, "", state);
    });
  }

  getLanguageData() {
    this.push(
      this.languageTranslateService.wordSrc$.subscribe((data) => {
        if (Object.keys(data).length != 0) {
          this.translate = data;
          console.log("translate", this.translate);
        }
      }),
    );
  }

  push(obs: any) {
    super.push(obs);
  }

  sendDataToFieldEx(code: string, realmId: string, state: string) {
    this.spinner.show();
    this.xeroServc.verifyConnection(code, "", state).subscribe({
      next: (res) => {
        this.spinner.hide();
        console.log("res printing from xero verify connection api", res);
        if (res.status === 200 || res.status === 201) {
          console.log(res, "verification completed..", res);
          const data = { isVerified: true };
          console.log(
            "window.location.origin printing",
            window.location.origin,
          );
          if (window.opener) {
            window.opener.postMessage(data, window.location.origin);
          }

          window.close();
        } else {
          this.errorUtil.setErrorMessage(
            res.status,
            "Connection to Xero failed. Please try again",
            null,
            "error",
            2000,
          );
        }
      },
      error: (err: any) => {
        this.spinner.hide();
        console.log("err printing from Xero verify connection api", err);
        this.errorUtil.setErrorMessage(
          err.status,
          err.error ? err.error.message : null,
          err.error ? err.error.message : null,
          "error",
          2000,
        );
      },
    });
  }
}
